<template>
  <div class="freight-detail">
    <div class="freight-detail-table">
      <vxe-grid
        border
        show-overflow
        resizable
        ref="freightDetailRef"
        class="vxe-table-element"
        size="mini"
        align="center"
        :auto-resize="true"
        :data="tableData"
        :toolbar="{}"
        :valid-config="{ autoPos: true, message: 'inline' }"
        :checkbox-config="{ checkMethod: this.activeCheckMethod }"
        @select-change="handleSelectionChange"
        @select-all="handleSelectionChange"
        @edit-closed="closeEditTableHandler"
        height="300"
      >
        <template v-slot:buttons v-if="!disabled">
          <el-button @click="newRowHandler" size="small" type="primary" class="vxe-btn-primary"
            >新建货物</el-button
          >
          <el-button @click="editRowHandler" size="small" type="primary" class="vxe-btn-primary"
            >编辑货物</el-button
          >
          <el-button @click="deleteRowHandler" size="small" type="danger" class="vxe-btn-delete"
            >删除</el-button
          >
        </template>
        <vxe-table-column type="checkbox" width="50" fixed="left"> </vxe-table-column>
        <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in chartColumns"
          :key="index"
          :type="item.type"
          :fixed="item.fixed"
          :field="item.field"
          :title="item.title"
          :width="item.width"
          :edit-render="item.editRender"
        >
          <template v-slot="{ row }">
            <span v-if="item?.field == 'cargoType'">{{
              $refs.dialogRef.getUnitName('Type', row[item.field])
            }}</span>
            <span v-else-if="item?.field == 'cargoCategory'">{{
              $refs.dialogRef.getUnitName('Category', row[item.field])
            }}</span>
            <span v-else>{{ row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </vxe-grid>
    </div>
    <EditFreightDialog
      ref="dialogRef"
      @confirmHandler="confirmHandler"
      @sendData="sendData"
    ></EditFreightDialog>
  </div>
</template>

<script>
  import { chartColumns } from './columns.js';
  import ProjectCommonMixin from '@/pages/park/warehouse/project/mixins//projectCommonMixin';
  import EditFreightDialog from './editFreightDialog';
  // import BASEAPI from '@/api/dataBase.js';
  export default {
    name: 'FreightDetailChart',
    mixins: [ProjectCommonMixin],
    components: {
      EditFreightDialog,
    },
    props: {
      tableDataList: {
        type: Array,
        default: () => [],
      },
      disabled: {
        type: Boolean,
        default: () => false,
      },
      pageMode: {
        type: Number,
        default: 0,
      },
    },
    data() {
      return {
        tableTotal: 0,
        selectedList: [],
        tableData: [],
        chartColumns,
        goodsTypeList: [],
        goodsCategoryList: [],
      };
    },
    methods: {
      activeCheckMethod() {
        //是否可以编辑
        return true;
      },
      sendData(goodsTypeList, goodsCategoryList) {
        this.goodsTypeList = goodsTypeList;
        this.goodsCategoryList = goodsCategoryList;
      },
      clearSelection() {
        this.$refs.freightDetailRef.clearCheckboxRow();
        this.selectedList = [];
      },
      //新插入一行或者编辑
      async confirmHandler(data, isEdit) {
        if (isEdit) {
          const list = this.$refs.freightDetailRef?.getTableData()?.fullData;
          const index = list.findIndex((item) => item._XID == data._XID);
          list.splice(index, 1, data);
          this.tableData = list;
        } else {
          await this.insertEvent(data, 0);
          this.tableData = this.getTableData();
        }
        this.$emit('handleChartChange', this.tableData);
      },
      // 新增行
      async newRowHandler() {
        this.clearSelection();
        this.$refs.dialogRef.openModal();
      },
      editRowHandler() {
        if (this.selectedList.length && this.selectedList.length == 1) {
          // this.$refs.dialogRef.openModal(this.selectedList[0]);
          let item = { ...this.selectedList[0] };
          this.$refs.dialogRef.openModal(item);
          this.clearSelection();
        } else if (this.selectedList.length > 1) {
          this.$message.error('请选择一行操作');
        } else {
          this.$message.error('请选择行操作');
        }
      },
      async insertEvent(rowData = {}, index = 0) {
        const $table = this.$refs.freightDetailRef;
        const errMap = await $table.validate().catch((errMap) => errMap);
        if (!errMap) {
          const { row: newRow } = await $table.insertAt(rowData, index);
          await $table.setActiveRow(newRow); // 设置当前行为活跃
          await $table.validate(newRow).catch((errMap) => errMap);
        }
      },
      //删除
      deleteRowHandler() {
        if (!this.selectedList.length) {
          this.$message.error('请选择行操作');
          return;
        }
        if (this.selectedList.length < 1) {
          this.$message({
            showClose: true,
            message: this.$t('billDetail.message.noData'),
            type: 'error',
          });
          console.log(111);
          return;
        }
        this.$confirmAction()
          .then(() => {
            this.$refs.freightDetailRef.removeSelecteds();
            // this.selectedList.forEach(item=>{
            //   this.tableData.splice(this.tableData.indexOf(item),1)
            // })
            this.selectedList = {};
            this.tableData = this.getTableData();
            this.$emit('handleChartChange', this.tableData);
            this.$message({
              showClose: true,
              type: 'success',
              message: this.$t('billDetail.message.deleteSuccess'),
            });
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('billDetail.message.cancelled'),
            });
          });
      },
      handleSelectionChange({ selection }) {
        console.log(selection, '选择行');
        this.selectedList = selection;
      },
      handleChange(row, field) {
        console.log(row, field, '行');
        // if (field === 'currencyCode') {
        //   row['currencyName'] = this.currencyList?.find(
        //     (item) => item.value == row['currencyCode']
        //   )?.label;
        // } else if (field === 'receivableExpenseType') {
        //   row['receivableExpenseTypeLabel'] = this.expenseType?.find(
        //     (item) => item.value == row[field]
        //   )?.label;
        // } else if (field === 'originalAmount') {
        //   row['domesticAmount'] = (row['originalAmount'] * row['exchangeRate']).toFixed(2);
        // }
      },
      async closeEditTableHandler() {
        console.log('关闭');
        // const $table = this.$refs.settleAccountsRef;
        // const errMap = await $table.validate().catch((errMap) => errMap);
        // if (errMap) {
        //   this.$message.error('请检查数据再提交');
        // } else {
        //   // 派发事件
        //   this.$emit('closeEditTableHandler', this.getTableData());
        //   await $table.clearActived();
        // }
      },
      // 获取表格数据
      getTableData() {
        const $table = this.$refs.freightDetailRef;
        return $table.getTableData().fullData;
      },
      // 反填数据
      fullTableData(val) {
        if (val && val.length) {
          this.tableData = val;
        } else {
          this.tableData = [];
        }
      },
    },
    computed: {},
    watch: {
      tableDataList: {
        handler(val) {
          this.fullTableData(val);
        },
        immediate: true,
        deep: true,
      },
    },
    mounted() {},
  };
</script>

<style lang="scss" scoped>
  .freight-detail {
    background: #fff;

    .freight-detail-table {
      padding: 10px;
      box-sizing: border-box;
      padding-top: 0;
    }
  }
</style>
